module.exports = __webpack_public_path__ + "assets/img/601.f48dcf71.png";